import SmallPledgeAuditLog from './small-pledge-audit-log.vue';
export default SmallPledgeAuditLog;
